/**
 * 图片预加载
 * @param {Array} images 图片列表
 * @returns
 */
export const preloadImages = async (images) => {
  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = url;
    });
  };
  return Promise.all(images.map(imageItem => {
    return loadImage(imageItem);
  }));
};
// 兼容 webview IOS 12的情况下，输入框失焦后 实际视图被软盘往上顶
export const keyboardFix = function() {
  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    if (this.keyboardTimer) clearTimeout(this.keyboardTimer);
    this.keyboardTimer = setTimeout(() => {
      console.info('keyboardFix scrollTo');
      window.scrollTo(0, window.pageYOffset);
      clearTimeout(this.keyboardTimer);
    }, 200);
  }
};

export function optionChar(index) {
  const startCode = 65; // A
  return String.fromCharCode(startCode + index); // 选项值
}

// 判断是否是webview环境，如果是拦截a标签点击事件，防止跳转。
export function interceptLink(el, isWebView, cb) {
  if (!isWebView) {
    return;
  }
  const aTags = el.querySelectorAll('a');
  aTags.forEach((aTag) => {
    aTag.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const href = aTag.getAttribute('href');
      const target = aTag.getAttribute('target');
      cb(href, target);
    });
  });
  // TODO 该方式在safari有问题，待排查
  // el.addEventListener('click', (e) => {
  //   // 获取事件源
  //   const targetItem = e.path[0];
  //   console.log(e, targetItem, targetItem.tagName);
  //   alert(targetItem.tagName);
  //   // 判断target是否为a标签
  //   if (targetItem.tagName === 'A') {
  //     const href = targetItem.getAttribute('href');
  //     const target = targetItem.getAttribute('target');
  //     cb(href, target);
  //     e.preventDefault();
  //     e.stopPropagation();
  //   }
  // });
}
/**
 * 随机产生m - n 数
 * @param m 最大值
 * @param n 最小值
 * @returns number
 */
export function randomSecond(n, m) {
  return Math.random() * (m - n) + n;
}

export function sleep(time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

/** 手机号码分段显示, 并支持中间4位显示为*号 */
export function formatMobileNumber(mobileNumber, hideMiddle = false) {
  if (hideMiddle) {
    return mobileNumber.slice(0, 3) + ' **** ' + mobileNumber.slice(7);
  }
  return mobileNumber.slice(0, 3) + ' ' + mobileNumber.slice(3, 7) + ' ' + mobileNumber.slice(7);
}

// 是否为iPhone X以上的型号（iPhone X / Xs / XR）
export function isMoreThanIPhoneX() {
  // iPhone X、iPhone XS
  const isIphone = navigator.userAgent.toLowerCase().match(/iphone/);
  const isIPhoneX = isIphone && window.screen.width === 375 && window.screen.height === 812;
  // iPhone XS Max
  const isIPhoneXSMax = isIphone && window.screen.width === 414 && window.screen.height === 896;
  // iPhone XR
  const isIPhoneXR = isIphone && window.screen.width === 414 && window.screen.height === 896;

  return isIPhoneX || isIPhoneXSMax || isIPhoneXR;
}

/**
 * 比较两个版本号，version1高于version2返回大于0
 * @param {String} version1
 * @param {String} version2
 */
export const compareVersions = (version1, version2) => {
  const reg = /(\.0+)+$/;
  const segA = version1.replace(reg, '').split('.');
  const segB = version2.replace(reg, '').split('.');
  const len = Math.min(segA.length, segB.length);
  for (let i = 0; i < len; i++) {
    const diff = parseInt(segA[i], 10) - parseInt(segB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segA.length - segB.length;
};

// 函数来自 @polyv/utils@2.x，因为项目还在用 1.x，所以暂时复制过来
export const supportWebP = (() => {
  function check() {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
      const mimeType = 'image/webp';
      return elem.toDataURL(mimeType).indexOf('data:' + mimeType) === 0;
    }
    return false;
  }

  let result;
  return () => {
    if (result == null) { result = check(); }
    return result;
  };
})();

// 生成 OSS 压缩参数
function genOSSCompressParams(extname, options) {
  let ossProccess = '';

  if (options.width != null || options.height != null) {
    ossProccess += '/resize';
    if (options.width) { ossProccess += ',w_' + options.width; }
    if (options.height) { ossProccess += ',h_' + options.height; }
    ossProccess += ',limit_1';
  }

  if (options.allowAVIF && extname !== 'gif') {
    ossProccess += '/format,avif';
  } else if (
    options.allowWebP === true || (options.allowWebP === 'auto' && supportWebP())
  ) {
    ossProccess += '/format,webp/quality,Q_80';
  } else if (options.allowJPG && extname !== 'gif') {
    ossProccess += '/format,jpg/quality,Q_80';
  }

  return ossProccess;
}

// 替换或追加压缩参数
function setOSSCompressParams(search, params) {
  let replaced = false;
  search = search.replace(/([?&]x-oss-process)(?:=([^&]*))?/, (match, p1, p2) => {
    replaced = true;
    return !/^image/.test(p2) ?
      match :
      p1 + '=' + p2.replace(/\/(?:resize|format|quality)[^/]*/gi, '') + params;
  });

  return replaced ?
    search :
    search +
      (search.indexOf('?') === -1 ? '?' : '&') +
      'x-oss-process=image' +
      params;
}

/**
 * 如果指定图片 URL 的域名是 OSS 域名，且没有任何 OSS 处理参数，则根据压缩选项追加 OSS 图片压缩处理参数。
 * @param url 指定图片 URL。
 * @param options 压缩选项。
 * @returns 处理后的图片 URL。
 */
export function ossCompress(url, options) {
  let urlObj;

  if (typeof document !== 'undefined') {
    const a = document.createElement('a');
    a.href = url;
    urlObj = a;
  } else if (typeof URL === 'function') {
    try {
      urlObj = new URL(/^\/\//.test(url) ? ('https:' + url) : url);
    } catch {}
  }

  if (!urlObj) { return url; }

  const filename = (urlObj.pathname.split('/').pop() || '').split('.');
  const extname = filename[filename.length - 1].toLowerCase();

  // 仅处理 CDN 域名
  if (!/\.videocc\.net$/i.test(urlObj.hostname) || extname === 'svg') { return url; }

  options = options ?? {};
  options.allowJPG = options.allowJPG ?? true;
  options.allowWebP = options.allowWebP ?? 'auto';

  const ossProcess = genOSSCompressParams(extname, options);
  if (ossProcess) {
    urlObj.search = setOSSCompressParams(urlObj.search, ossProcess);
  }

  return urlObj.href;
}

/**
 * 对指定 HTML 代码中 img 标签的图片地址做 OSS 压缩处理。
 * @param html 指定 HTML 代码。
 * @param options 压缩选项。
 * @returns 处理后的 HTML 代码。
 */
export function compressHTMLImgs(html, options) {
  if (!html) { return ''; }
  return html.replace(
    /(<img.*?\ssrc=)(["']?)(.+?)\2(.*?>)/gi,
    (match, before, quot, src, after) => {
      return before + '"' + ossCompress(src, options) + '"' + ' data-src="' + src + '"' + after;
    },
  );
}

/**
 * 从版本号中提取中间部分
 * 例如：1.17.0-rc-20250812.1 => rc-20250812
 */
export function extractVersionMiddlePart(versionString) {
  const match = versionString.match(/^\d+\.\d+\.\d+-(.+)\.\d+$/);
  return match ? match[1] : '';
}
